var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",class:_vm.footer === 'true' ? 'contact-form-1' : 'contact-form-2',on:{"click":_vm.openContactForm}},[_c('p',{staticClass:"title"},[_vm._v("CONTACT US")])])
}
var staticRenderFns = []

export { render, staticRenderFns }